import { createRouter, createWebHistory } from 'vue-router'
import AOS from 'aos'

import MainLayout from '@/components/main_layout.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: '',
          name: 'index',
          component: () => import('@/views/index.vue'),
        },
        {
          path: 'about/index',
          name: 'aboutIndex',
          component: () => import('@/views/about/index.vue'),
        },
        {
          path: 'about/sum',
          name: 'aboutSum',
          component: () => import('@/views/about/sum.vue'),
        },
        {
          path: 'about/tissue',
          name: 'aboutTissue',
          component: () => import('@/views/about/tissue.vue'),
        },
        {
          path: 'about/culture',
          name: 'aboutCulture',
          component: () => import('@/views/about/culture.vue'),
        },
        {
          path: 'about/history',
          name: 'aboutHistory',
          component: () => import('@/views/about/history.vue'),
        },
        {
          path: 'about/culture2',
          name: 'aboutCulture2',
          component: () => import('@/views/about/culture2.vue'),
        },
        {
          path: 'young',
          name: 'young',
          component: () => import('@/views/young.vue'),
        },
        {
          path: 'news/index',
          name: 'newsIndex',
          component: () => import('@/views/news/index.vue'),
        },
        {
          path: 'news/jujiao',
          name: 'newsJujiao',
          component: () => import('@/views/news/jujiao.vue'),
        },
        {
          path: 'news/meiti',
          name: 'newsMeiti',
          component: () => import('@/views/news/meiti.vue'),
        },
        {
          path: 'news/index',
          name: 'newsIndex',
          component: () => import('@/views/news/index.vue'),
        },
        {
          path: 'news/jujiao',
          name: 'newsJujiao',
          component: () => import('@/views/news/jujiao.vue'),
        },
        {
          path: 'news/detail',
          name: 'newsDetail',
          component: () => import('@/views/news/detail.vue'),
        },
        {
          path: 'business/index',
          name: 'businessIndex',
          component: () => import('@/views/business/index.vue'),
        },
        {
          path: 'business/realty',
          name: 'businessRealty',
          component: () => import('@/views/business/realty.vue'),
        },
        {
          path: 'business/tenement',
          name: 'businessTenement',
          component: () => import('@/views/business/tenement.vue'),
        },
        {
          path: 'business/trade',
          name: 'businessTrade',
          component: () => import('@/views/business/trade.vue'),
        },
        {
          path: 'business/innovate',
          name: 'businessInnovate',
          component: () => import('@/views/business/innovate.vue'),
        },
        {
          path: 'corporate-information',
          name: 'corporate-information',
          component: () => import('@/views/corporate-information.vue'),
        },
        {
          path: 'corporate-governance',
          name: 'corporate-governance',
          component: () => import('@/views/corporate-governance.vue'),
        },
        {
          path: 'announcements',
          name: 'announcements',
          component: () => import('@/views/announcements.vue'),
        },
        {
          path: 'fin-reports',
          name: 'fin-reports',
          component: () => import('@/views/fin-reports.vue'),
        },
        {
          path: 'esg-reports',
          name: 'esg-reports',
          component: () => import('@/views/esg-reports.vue'),
        },
        {
          path: 'presentations',
          name: 'presentations',
          component: () => import('@/views/presentations.vue'),
        },
        {
          path: 'newsletters',
          name: 'newsletters',
          component: () => import('@/views/newsletters.vue'),
        },
        {
          path: 'lean-governance',
          name: 'lean-governance',
          component: () => import('@/views/lean-governance.vue'),
        },
        {
          path: 'better-life',
          name: 'better-life',
          component: () => import('@/views/better-life.vue'),
        },
        {
          path: 'green-earth',
          name: 'green-earth',
          component: () => import('@/views/green-earth.vue'),
        },
        {
          path: 'people-oriented',
          name: 'people-oriented',
          component: () => import('@/views/people-oriented.vue'),
        },
        {
          path: 'co-development',
          name: 'co-development',
          component: () => import('@/views/co-development.vue'),
        },
        {
          path: 'join/index',
          name: 'joinIndex',
          component: () => import('@/views/join/index.vue'),
        },
        {
          path: 'join/staff',
          name: 'joinStaff',
          component: () => import('@/views/join/staff.vue'),
        },
        {
          path: 'join/job',
          name: 'joinJob',
          component: () => import('@/views/join/job.vue'),
        },
        {
          path: 'contact',
          name: 'contact',
          component: () => import('@/views/contact.vue'),
        },
        {
          path: 'business-area',
          name: 'business-area',
          component: () => import('@/views/business-area.vue'),
        },
        {
          path: 'law',
          name: 'law',
          component: () => import('@/views/law.vue'),
        },
        {
          path: 'privacy',
          name: 'privacy',
          component: () => import('@/views/privacy.vue'),
        },
        {
          path: 'gongyi',
          name: 'gongyi',
          component: () => import('@/views/gongyi.vue'),
        },
      ],
    },
  ],
})

// router.afterEach(() => {
//   AOS.refresh()
// })
router.afterEach(() => {
  nextTick(() => {
    AOS.refresh()
  })
})
export default router
